import { createContext, useState } from "react";
import {
  Bars3Icon,
  MagnifyingGlassIcon,
  BellIcon,
  Cog6ToothIcon,
  ArrowLeftEndOnRectangleIcon,
  MoonIcon,
  SunIcon,
} from "@heroicons/react/24/outline";
import { useDispatch, useSelector } from "react-redux";
import { logout, logoutUser } from "../slices/userSlice"; // Importamos logout y logoutUser desde el userSlice
import { useNavigate } from "react-router-dom";
import Logo from "../assets/4.png";
import logoDark from "../assets/9.png"
import { SidebarItem } from "./SidebarItem";
import { Popover } from "antd";
import PopoverSettings from "./elements/PopoverSettings";
import PopoverNotifications from "./elements/PopoverNotifications";

import ModalSearch from "./elements/ModalSearch";
import { toggleDarkMode } from "../slices/darkModeSlice";
import ModalLogout from "./elements/ModalLogout";



const SidebarContext = createContext();
export default function Navbar({ routes }) {
  const { expanded } = useSelector((state) => state.sidebar);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);

  const { isDarkMode } = useSelector((state) => state.darkMode);

  const [searchModalOpen, setSearchModalOpen] = useState(false);
  const [notificationsModal, setNotificationModal] = useState(false)
  const [settingsPopover, setIsSettingsPopover] = useState(false)
  

  const dispatch = useDispatch();
  const navigate = useNavigate(); // Usamos el hook de react-router-dom para redirigir

  const handleLogout = () => {
    console.log("Iniciando logout..."); // Verifica si esto se imprime
    dispatch(logoutUser())
      .then(() => {
        console.log("Logout exitoso"); // Verifica si esto se imprime
        dispatch(logout()); // Limpia el estado en Redux
        navigate("/login"); // Redirige al usuario a la página de login
      })
      .catch((error) => {
        console.error("Error durante el logout:", error); // Verifica si hay errores
      });
  
    setIsLogoutModalOpen(false);
  };
  

  return (
    <header className="bg-background shadow-md sticky top-0 left-0 right-0 z-10 w-full sm:mb-0 mb-3   ">
      <div className="flex justify-between items-center p-4 w-full max-w-full">
        {/* Barra lateral y logo alineados a la izquierda */}
        <div className="flex justify-between items-center sm:space-x-4 flex-1">
          <div className="flex items-center space-x-4">
            <h2 className="font-semibold text-xl text-gray-800 sm:block hidden dark:text-white ">
              Admin Dashboard
            </h2>
            <div className="sm:ml-0 ">
              <img src={isDarkMode ? logoDark : Logo} alt="Logo" className={` ${isDarkMode ? "w-12 h-10" :"h-8 w-8" } `} />
            </div>
          </div>
          
          <div className="sm:hidden flex items-center space-x-4 mr-4">
          <button
              onClick={() => dispatch(toggleDarkMode())}
              className=" sm:hidden block ml-4 text-gray-600 hover:text-indigo-600"
            >
              {isDarkMode ? (
                <SunIcon className="h-5 w-5 " />
              ) : (
                <MoonIcon className="h-5 w-5 " />
              )}
            </button>
            <button className=" sm:hidden block ml-16 items-center space-x-2 text-gray-600 hover:text-indigo-600">
              <MagnifyingGlassIcon onClick={() => setSearchModalOpen(true) } className="h-5 w-5" />
            </button>

            
            <button onClick={() => setNotificationModal(true)} className="sm:hidden block ml-4 items-center space-x-2 text-gray-600 hover:text-indigo-600">
              <BellIcon className="h-5 w-5" />
            </button>

            
            
          </div>
        </div>

        {/* Íconos de la derecha (para pantallas grandes) */}
        <div className="hidden md:flex items-center space-x-4">
          <div className="relative">
            <MagnifyingGlassIcon onClick={() => setSearchModalOpen(true) } className="absolute top-1/2 transform -translate-y-1/2 right-3 h-5 w-5 text-gray-500 cursor-pointer " />
          </div>

         
          
          <button onClick={() => setIsSettingsPopover(true) } className="text-gray-600 hover:text-indigo-600 p-2 rounded-full">
            <Cog6ToothIcon className="h-6 w-6" />
          </button>
         

          
          <button onClick={() => setNotificationModal(true)} className="text-gray-600 hover:text-indigo-600 p-2 rounded-full relative">
            <BellIcon className="h-6 w-6" />
            <span className="absolute top-0 right-0 block w-2.5 h-2.5 bg-red-500 rounded-full border-2 border-white"></span>
          </button>

          
          
          <button
            className="text-gray-600 hover:text-red-600 p-2 rounded-full"
            onClick={() => setIsLogoutModalOpen(true)}
          >
            <ArrowLeftEndOnRectangleIcon className="h-6 w-6" />
          </button>
        </div>

        {/* Menú móvil (que aparece cuando el tamaño de pantalla es pequeño) */}
        <button
          className="md:hidden text-gray-600"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <Bars3Icon className="h-6 w-6" />
        </button>

        {/* Menú desplegable para móviles */}
        {mobileMenuOpen && (
          <div className="absolute top-16 right-0 bg-background shadow-md border border-border p-4 w-64 rounded-lg md:hidden">
            <ul className="space-y-4">
              <SidebarContext.Provider value={{ expanded }}>
                <li>
                  {routes[0].pages.map((route) => (
                    <SidebarItem
                      key={route.name}
                      icon={route.icon}
                      text={route.name}
                      expanded={expanded}
                      path={"/admin" + route.path}
                    />
                  ))}
                </li>
              </SidebarContext.Provider>

              

              <li>

                <button
                  className="flex items-center space-x-5 text-red-500 hover:text-red-600 px-2 "
                  onClick={() => setIsLogoutModalOpen(true)}
                >
                  <ArrowLeftEndOnRectangleIcon className="h-5 w-5" />
                  <span>Logout</span>
                </button>
              </li>
            </ul>
          </div>
        )}
      </div>

      <ModalLogout handleLogout={handleLogout} isLogoutModalOpen={isLogoutModalOpen} setIsLogoutModalOpen={setIsLogoutModalOpen} />

      
     <ModalSearch searchModalOpen={searchModalOpen} setSearchModalOpen={setSearchModalOpen} />

      <PopoverNotifications notificationsModal={notificationsModal} setNotificationModal={setNotificationModal} />

      <PopoverSettings settingsPopover={settingsPopover} setIsSettingsPopover={setIsSettingsPopover} />
      
    </header>
  );
}
